import { createHeaders } from '@wix/headers';
import whitelistedHosts from './whitelist.json';
import { extractHost, isAbsoluteUrl } from './utils';
export var composeHeaders = function (_a) {
    var url = _a.url, disableWixHeaders = _a.disableWixHeaders, wixHeadersOpts = _a.wixHeadersOpts;
    var shouldAssignWixHeaders = !disableWixHeaders && isWixDomain(url);
    return shouldAssignWixHeaders ? createHeaders(wixHeadersOpts) : {};
};
export function isWixDomain(url) {
    var isRelative = !isAbsoluteUrl(url);
    if (isRelative) {
        return true;
    }
    var host = "." + extractHost(url);
    var isWhitelisted = whitelistedHosts.find(function (wixHost) {
        return host.endsWith("." + wixHost);
    });
    return !!isWhitelisted;
}
//# sourceMappingURL=headers.js.map